import $ from "jquery"
import './SocialAccounts.css'
import '../../js/custom'
import React, { Component,Fragment } from 'react'
import { ArrowForward } from "@material-ui/icons"



export default class SocialAccounts extends Component {
  constructor(props) {
    super(props)
   
  }

  render() {
//     console.log('insta')

// console.log(this.props.insta.edges)
    return (
      <div>
           <div className="container margin-spacing">
            <div className="row mt-sm-5  ">
         <div className="col-12 col-sm-12 col-md-6 mt-5">
           <h1>Twitter</h1>
           <a
             className="twitter-timeline"
             data-height="420"
             href="https://twitter.com/selectedwisdom?ref_src=twsrc%5Etfw"
           >
             Tweets by selectedwisdom
           </a>{" "}
           <div className="d-flex justify-content-end mt-5"><a href="https://twitter.com/selectedwisdom?ref_src=twsrc%5Etfw" target="_blank" style={{color : '#000000'}}>Follow</a>
<ArrowForward/>
</div>
         </div>
         <div className="col-12 col-sm-12 col-md-6 mt-5">
           <h1>Instagram</h1>
           <div className="row mt-5">
           {this.props.insta.edges.slice(0,6).map((edge) => {
                return (
           <div className="col-4">
             <a href="https://www.instagram.com/getselectedwisdom/" target="_blank">

<img src={edge.node.preview}/>
             </a>
           </div>
                )})}

                </div>
<div className="d-flex justify-content-end mt-5"><a href="https://www.instagram.com/getselectedwisdom/" target="_blank" style={{color : '#000000'}}>Follow</a>
<ArrowForward/>
</div>
         </div>
       </div>
       </div>
      </div>
    )
  }
}

